module.exports = __webpack_public_path__ + "assets/img/app-dec5.87be31ff.svg";